import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderMdx } from "@/components/content/render-mdx";
import {
  Article,
  ArticleContainer,
  ArticleDescription,
  ArticleHeader,
  ArticleHeading,
} from "@/components/primitives/article";
import { PageContainer } from "@/components/primitives/layout";

const getPrivacyData = createServerFn({ method: "GET" }).handler(async () => {
  const { privacy } = await import("../../.velite");
  if (privacy.length !== 1) {
    throw new Error("Expected exactly one privacy policy document");
  }
  return privacy[0];
});

export const Route = createFileRoute("/privacy")({
  loader: () => getPrivacyData(),
  head: ({ loaderData }) => ({
    meta: [
      { title: `${loaderData?.title ?? "Privacy Policy"} - Scoopulator` },
      { name: "description", content: loaderData?.description ?? "" },
    ],
  }),
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  const policy = Route.useLoaderData();

  return (
    <PageContainer>
      <ArticleContainer>
        <ArticleHeader>
          <ArticleHeading>{policy.title}</ArticleHeading>
          <ArticleDescription>
            Last updated:{" "}
            {new Date(policy.updatedAt).toLocaleDateString(undefined, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </ArticleDescription>
        </ArticleHeader>
        <Article>{renderMdx(policy.body)}</Article>
      </ArticleContainer>
    </PageContainer>
  );
}
